import api from '../Utils/api'

export const contextSearch = async (search) => {
  const apiResponse = await api('GET', `search?search=${search}`, null, true)
  return apiResponse
}

export const searchEvents = async (search) => {
  const now = Date.now()
  const apiResponse = await api('POST', 'events/search', {search, currentTime: now})
  return apiResponse
}

export const ask = async (search, tags, events) => {
  const apiResponse = await api(
    'GET',
    `questions?search=${search}&tags=${
      tags ? tags?.filter((tag) => tag !== '').join(',') : ''
    }&events=${
      events ? events?.filter((event) => event !== '').join(',') : ''
    }`,
    null
  )
  return apiResponse
}
